
import {Vue, Component} from 'vue-property-decorator';
import {
  downloadClaimExcel,
  getClaimBaseInfo,
  getClaimReason,
  getCreateDetails,
  getDeductionMethod
} from "@/api/credit-note";

@Component({
  name: 'ClaimFormDetail',
})
export default class extends Vue {
  private show = false;
  private claimFormId = "";
  private claimInfoFrom = {
    deductionMethod: "",
    claimReason: "",
    supplierAbb: "",
    timeOfIssue: "",
    claimProducts: "",
    purchaseOrders: "",
    oeNumberDesc: "",
    hqNumberDesc: "",
    refNumberDesc: "",
    claimNumber: 0,
    reasonForComplaint: "",
    claimAmount: 0,
    supplierProcessingResults: "",
    supplierConfirmingPersonnel: "",
    supplierConfirmationDate: "",
    remark: "",
  };

  private showClaimBaseInfo = false;
  private claimBaseInfoFrom = {};
  private deductionMethodOptions = [];
  private claimReasonOptions = [];

  created() {
    this.getDeductionMethod();
    this.getClaimReason();
  }

  private async getDeductionMethod() {
    this.deductionMethodOptions = await getDeductionMethod() as any;
  }

  private async getClaimReason() {
    this.claimReasonOptions = await getClaimReason() as any;
  }

  public async openDialog(id) {
    this.show = true;
    this.claimFormId = id;
    this.claimInfoFrom = await getCreateDetails(id) as any;
    this.claimInfoFrom.deductionMethod = this.deductionMethodOptions.find(item =>
        item.name === this.claimInfoFrom.deductionMethod
    )?.desc??"";
    const claimReasons = this.claimReasonOptions.flatMap(item => item.children);
    this.claimInfoFrom.claimReason = claimReasons.find(item =>
        item.value === this.claimInfoFrom.claimReason
    )?.label??"";
  }

  private async getClaimBaseInfo() {
    this.claimBaseInfoFrom = await getClaimBaseInfo(this.claimFormId) as any;
    this.showClaimBaseInfo = true;
  }

  private async downloadClaimExcel() {
    await downloadClaimExcel(this.claimFormId);
  }
}
